var map = {
	"./addressBook.svg": "7fce",
	"./auth.svg": "4e70",
	"./chatList.svg": "76a6",
	"./communication.svg": "e9cf",
	"./communicationNew.svg": "5928",
	"./layoutChat.svg": "12ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";